import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  withArrow?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  withArrow = false,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-heading font-bold uppercase tracking-wider transition-all duration-300 rounded-sm';
  const variants = {
    primary: 'bg-sand text-charcoal-dark hover:bg-amber hover:shadow-[0_0_20px_rgba(212,165,116,0.4)]',
    secondary: 'bg-charcoal-light text-offwhite hover:bg-charcoal border border-charcoal-light hover:border-sand',
    outline: 'bg-transparent text-sand border-2 border-sand hover:bg-sand hover:text-charcoal-dark'
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-8 py-4 text-sm',
    lg: 'px-10 py-5 text-base md:text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  const content = <>
      {children}
      {withArrow && <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-351" data-mp="to899wnc63b8" />}
    </>;
  if (href) {
    return <a href={href} className={classes} target="_blank" rel="noopener noreferrer" data-id="element-352" data-mp="om95wmrlj6ea">
        {content}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-353" data-mp="xpa8wel60hdq">
      {content}
    </button>;
}